import styled from "styled-components";
import Colors from "../../styles/colors";
import { mixFont } from "../../styles/mixins";
import { withIsMobile } from "../../api/hooks/use-is-mobile";

const getItem = (obj, isMobile) =>
  obj.desktop && obj.mobile ? obj[isMobile ? "mobile" : "desktop"] : obj;

export const Constants = {
  height: 24,
  width: 60,
  margin: {
    regular: {
      top: {
        desktop: 130,
        mobile: 70,
      },
      bottom: {
        desktop: 70,
        mobile: 60,
      },
    },
    detail: {
      top: 20,
      bottom: 35,
    },
  },
  font: {
    size: 12,
    height: 24,
    color: "black",
    family: "FuturaPT-Book",
  },
  line: {
    height: 1,
    color: Colors.goldLight,
    colorFull: Colors.goldDark,
  },
};

// eslint-disable-next-line import/prefer-default-export
export const StyledHeading = styled.div`
  padding-top: ${({ variant = "regular", isMobile }) =>
    getItem(Constants.margin[variant].top, isMobile)}px;
  padding-bottom: ${({ variant = "regular", isMobile }) =>
    getItem(Constants.margin[variant].bottom, isMobile)}px;
  ${(props) => {
    return props.styles;
  }};
`;

export const StyledWrapper = styled.div`
  text-align: center;
  position: relative;
  span {
    display: inline-block;
    background: white;
    letter-spacing: 3px;
    height: ${Constants.height}px;
    ${mixFont(Constants.font)}
    position: relative;
    text-transform: uppercase;
    ${({ fullWidth }) =>
      fullWidth
        ? `
          padding: 0 ${Constants.width}px;
        `
        : `
          width: ${Constants.width}px;
        `}
  }
  &:before {
    content: "";
    position: absolute;
    z-index: 0;
    left: 0;
    right: 0;
    top: calc(50% - ${Constants.line.height / 2}px);
    height: ${Constants.line.height}px;
    background: ${({ fullWidth }) =>
      fullWidth ? Constants.line.colorFull : Constants.line.color};
  }
`;

export const Heading = withIsMobile(StyledHeading);
